import { useEffect, useMemo, useRef, useState } from "react";

const fmt = (v) => Number(v ?? 0).toLocaleString("ro-RO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const norm = (v) => String(v || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export function SkuAutocomplete({ value, onPick, catalog, testId }) {
  const [q, setQ] = useState(value || "");
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const inputRef = useRef(null);
  // Fixed positioning so the dropdown isn't clipped by scrollable parents.
  const openDropdown = () => {
    const r = inputRef.current?.getBoundingClientRect();
    if (r) setPos({ top: r.bottom + 4, left: r.left });
    setOpen(true);
  };
  useEffect(() => { setQ(value || ""); }, [value]);

  const matches = useMemo(() => {
    const words = norm(q).trim().split(/\s+/).filter(Boolean);
    if (!words.length) return catalog.slice(0, 20);
    return catalog.filter((c) => {
      const hay = `${norm(c.sku)} ${norm(c.name)}`;
      return words.every((w) => hay.includes(w));
    }).slice(0, 20);
  }, [q, catalog]);

  return (
    <div className="relative">
      <input value={q}
        ref={inputRef}
        onFocus={openDropdown}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        onChange={(e) => { setQ(e.target.value); openDropdown(); }}
        data-testid={testId}
        placeholder="Caută după SKU sau nume..."
        className="w-full rounded border border-zinc-800 bg-zinc-900 px-2 py-1 font-mono text-sm text-sky-300 outline-none focus:border-orange-500/50" />
      {open && matches.length > 0 && (
        <div style={pos ? { position: "fixed", top: pos.top, left: pos.left } : undefined} className="absolute z-[60] mt-1 max-h-64 w-[640px] overflow-y-auto rounded-lg border border-zinc-700 bg-zinc-950 shadow-xl" data-testid={`${testId}-dropdown`}>
          {matches.map(m => (
            <button key={m.sku} onMouseDown={(e) => e.preventDefault()}
              onClick={() => { onPick(m); setQ(m.sku); setOpen(false); }}
              className="flex w-full items-center gap-2 px-2 py-1.5 text-left hover:bg-zinc-900">
              <span className="font-mono text-xs text-sky-300">{m.sku}</span>
              <span className="truncate text-[11px] text-zinc-300" title={m.name}>{m.name}</span>
              {m.compensation_amount != null && (
                <span className="ml-auto rounded bg-emerald-500/15 px-1.5 py-0.5 text-[10px] font-mono text-emerald-200">{fmt(m.compensation_amount)}</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
